import React, { useEffect, useRef, useState } from "react";
import "./styles/main.css";
import EmojiTray from "./components/EmojiTray";
import ChatInput from "./components/ChatInput";
import Header from "./components/Header";
import ChatSidebar from "./components/ChatSidebar";
import Icon from "components/Icon";
import Search from "./components/Search";
import Profile from "./components/Profile";
import Convo from "./components/Convo";
import { useUsersContext } from "context/usersContext";
import Picker from '@emoji-mart/react'
import data from '@emoji-mart/data'

const Chat = ({ match, history }) => {
	const { users, setUserAsUnread, addNewMessage , addNewFileMessage , searchData} = useUsersContext();
	const userId = match.params.id;
	// const userId = '63eb51ebb47df648de0699ce';
	// console.log('CHAT INDEX USER_ID', userId);
	// console.log('CHAT INDEX USERS: ' + JSON.stringify(users));
	// let json = JSON.parse(users);
	// console.log('MMMMMMM: ' + json);
	// let user = users.filter((user) => user.id === Number(userId))[0];
	let user = users.filter((user) => user._id === String(userId))[0];

	const lastMsgRef = useRef(null);
	const [showAttach, setShowAttach] = useState(false);
	const [showEmojis, setShowEmojis] = useState(false);
	const [showProfileSidebar, setShowProfileSidebar] = useState(false);
	const [showSearchSidebar, setShowSearchSidebar] = useState(false);
	const [newMessage, setNewMessage] = useState("");
	const [newFileMessage, setNewFileMessage] = useState("");
	const [isPickerVisible, setPickerVisible] = useState(false)
	const [currentEmoji, setCurrentEmoji] = useState(false)

	useEffect(() => {
		if (!user) history.push("/");
		else {
			scrollToLastMsg(false);
			setUserAsUnread(user._id);
		}
	}, []);

	useEffect(() => {
		user && scrollToLastMsg(false);
	}, [users]);

	const openSidebar = (cb) => {
		// close any open sidebar first
		setShowProfileSidebar(false);
		setShowSearchSidebar(false);

		// call callback fn
		cb(true);
	};



	const scrollToLastMsg = (scroll) => {
		if(scroll)
			lastMsgRef.current.scrollIntoView();
	};


	const submitNewMessage = () => {
		// console.log("submitNewMessage called");
		addNewMessage(user._id, newMessage);
		setNewMessage("");
		scrollToLastMsg();
	};

	const addEmoji = (emoji) => {
		setNewMessage(newMessage + emoji);
	};

	const submitNewFileMessage = (file) => {
		// console.log('submitNewFileMessage called ....',newFileMessage )
		// console.log('submitNewFileMessage called with file....',file )
		addNewFileMessage(user._id, file);
	};


	
	return (
		<div className="chat">
			<div className="chat__body">
				<div className="chat__bg"></div>

				<Header
					user={user}
					openProfileSidebar={() => openSidebar(setShowProfileSidebar)}
					openSearchSidebar={() => openSidebar(setShowSearchSidebar)}
				/>
				<div className="chat__content">
					<Convo lastMsgRef={lastMsgRef} messages={user?.messages} />
				</div>
				<footer className="chat__footer">
					<button
						className="chat__scroll-btn"
						aria-label="scroll down"
						onClick={scrollToLastMsg}
					>
						<Icon id="downArrow" />
					</button>
					{/* <EmojiTray
						showEmojis={showEmojis}
						newMessage={newMessage}
						setNewMessage={setNewMessage}
					/> */}
					{showEmojis ?
					<Picker 
					data={data} 
					previewPosition="none" 
					onEmojiSelect={(e) => {
						addEmoji(e.native)
					}}
					/> : ''}
					<ChatInput
						showEmojis={showEmojis}
						setShowEmojis={setShowEmojis}
						showAttach={showAttach}
						setShowAttach={setShowAttach}
						newMessage={newMessage}
						setNewMessage={setNewMessage}
						submitNewMessage={submitNewMessage}
						newFileMessage={newFileMessage}
						setNewFileMessage={setNewFileMessage}
						submitNewFileMessage={submitNewFileMessage}
					/>
				</footer>
				
			</div>
			<ChatSidebar
				heading="Search Messages"
				active={showSearchSidebar}
				closeSidebar={() => setShowSearchSidebar(false)}
			>
				<Search  />
			</ChatSidebar>

			<ChatSidebar
				heading="Contact Info"
				active={showProfileSidebar}
				closeSidebar={() => setShowProfileSidebar(false)}
			>
				<Profile user={user} />
			</ChatSidebar>
		</div>
	);
};

export default Chat;
